module.exports = __webpack_public_path__ + "img/people.46f10935.svg";